import { QuestionsColumnActionsController } from './questions-column-actions.controller';
import { QuestionsColumnActionsProps } from './questions-column-actions.model';

export const QuestionsColumnActions = (props: QuestionsColumnActionsProps) => {
  return <QuestionsColumnActionsController {...props} />;
};
